import React, {useState, useEffect} from 'react'
import styled from 'styled-components'

const GridContainer = styled.div.attrs({
  className: ''
})`
  display: grid;
  grid-template-rows: repeat(2, 1fr); /* 2 filas iguales */
  gap: 30px; /* Espacio entre las casillas */
  box-sizing: border-box;
  /* padding: 10px; */
  /* background-color: #f0f0f0; */

  @media (max-width: 768px) {
     gap: 10px;
  }
`

const Item1 = styled.div.attrs({
  className: ''
})`
  grid-column: 1 / 2; /* Primera columna */
  grid-row: 1 / 3;    /* Ocupa desde fila 1 hasta fila 2 */
  max-height: 500px;

  @media (max-width: 768px) {
     gap: 10px;
  }
`

const Item2 = styled.div.attrs({
  className: ''
})`
  grid-column: 2 / 3;
  grid-row: 1 / 2;
  max-height: 235px;
`

const Item3 = styled.div.attrs({
  className: ''
})`
  grid-column: 3 / 4;
  grid-row: 1 / 2;
  max-height: 235px;
`

const Item4 = styled.div.attrs({
  className: ''
})`
  grid-column: 2 / 3;
  grid-row: 2 / 3;
  max-height: 235px;
`

const Item5 = styled.div.attrs({
  className: ''
})`
  grid-column: 3 / 4;
  grid-row: 2 / 3;
  max-height: 235px;
`

const ProductImage = styled.img.attrs({
  className: ''
})`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 20px;
`

const ProductMasonry = (props) => {
  const {title, featured_image, images} = props

  return (
    <GridContainer>
      <Item1>
        <ProductImage src={featured_image} alt={`${title} - 1`} className="shadow-sm"/>
      </Item1>
      <Item2>
        <ProductImage src={images[0]} alt={`${title} - 2`} className="shadow-sm"/>
      </Item2>
      <Item3>
        <ProductImage src={images[1]} alt={`${title} - 3`} className="shadow-sm"/>
      </Item3>
      <Item4>
        <ProductImage src={images[2]} alt={`${title} - 4`}className="shadow-sm"/>
      </Item4>
      <Item5>
        <ProductImage src={images[3]} alt={`${title} - 5`} className="shadow-sm"/>
      </Item5>
    </GridContainer>
  )
}

export default ProductMasonry
